import { __rest } from "tslib";
import * as React from 'react';
import { ClassNames } from '../..';
import { useArmstrongConfig } from '../config/config.context';
export var DefaultLink = React.forwardRef(function (_a, forwardedRef) {
  var to = _a.to,
      className = _a.className,
      children = _a.children,
      additionalProps = __rest(_a, ["to", "className", "children"]);

  return React.createElement("a", Object.assign({
    ref: forwardedRef
  }, additionalProps, {
    className: className,
    href: to
  }), children);
});
/**
 * A component that renders an anchor tag or renders the LinkComponent given to routing on the ArmstrongConfigContext
 *
 * For internal Armstrong use for components that needs to be able to access routing i.e. LinkButton rather than for consumers to use directly
 */

export var Link = React.forwardRef(function (_a, ref) {
  var to = _a.to,
      className = _a.className,
      children = _a.children,
      additionalProps = __rest(_a, ["to", "className", "children"]);

  var _useArmstrongConfig = useArmstrongConfig(),
      routing = _useArmstrongConfig.routing;

  return React.createElement(routing.LinkComponent, Object.assign({}, additionalProps, {
    ref: ref,
    to: to,
    className: ClassNames.concat('arm-link', className)
  }), children);
});